import React, { useState } from "react";

const CustomRadio = ({ label, activeClass, shortOrLong, setShortOrLong }) => {
  //   const [checked, setChecked] = useState(true);
  const handleChange = (e) => {
    // setChecked(!checked);
    // console.log(checked);
    setShortOrLong(label);
  };
  return (
    <label
      htmlFor={label}
      className={`flex gap-[8px] w-[90px] cursor-pointer items-center justify-center rounded-[5px] portal-label h-full ${
        shortOrLong === label && activeClass
      }`}
    >
      <input
        checked={shortOrLong === label}
        onChange={handleChange}
        onClick={handleChange}
        id={label}
        type="radio"
      />
      <span className="font-bold text-[15px] leading-[22px] ">{label}</span>
    </label>
  );
};

export default CustomRadio;
